import api from "@/api";

export default {
  state: {
    companyTypes: [],
  },
  getters: {
    companyTypes: (state) => state.companyTypes,
  },
  mutations: {
    setCompanyTypes: (state, data) => {
      state.companyTypes = data;
    },
  },
  actions: {
    getCompanyTypes: async ({ commit }) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          "/v1/company-types"
        );
        const { data } = response.data;
        commit("setCompanyTypes", data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
